import React from 'react';
import DataTable from '../Components/DataTable';
import FormattedDate from '../Components/FormattedDate';
import './TablaTarjetas.css';

function TablaTarjetas({ onSelectionChange, loading, error, onRetry, emptyStateNoReload, pageSize, currentPage, onPageChange, ...props }) {
    const { tarjetas = [] } = props;

    const columns = [
        {
            Header: 'Número Tarjeta',
            accessor: 'NumeroTarjeta',
        },
        {
            Header: 'Nombre Cliente',
            accessor: 'NombreCliente',
            Cell: ({ value, row }) => {
                const nombreCompleto = row.original.NombreCompleto;
                const nombres = row.original.Nombres;
                const apellidos = row.original.Apellidos;
                
                if (nombreCompleto) return nombreCompleto;
                if (nombres || apellidos) return `${nombres || ''} ${apellidos || ''}`.trim();
                
                return 'Cliente no asignado';
            }
        },
        {
            Header: 'Vencimiento',
            accessor: 'Vencimiento',
        },
        {
            Header: 'Tipo',
            accessor: 'TipoTarjeta',
        },
        {
            Header: 'Estado',
            accessor: 'Estatus',
            Cell: ({ value }) => {
                const statusMap = {
                    'Activa': 'Activa',
                    'activa': 'Activa',
                    'Inactiva': 'Inactiva',
                    'inactiva': 'Inactiva',
                    'Bloqueada': 'Bloqueada',
                    'bloqueada': 'Bloqueada',
                    'Cancelada': 'Cancelada',
                    'cancelada': 'Cancelada'
                };
                return statusMap[value] || value || 'Desconocido';
            }
        }
    ];

    const getDefaultTarjetas = () => [
        {
            NumeroTarjeta: "4532123456789012",
            NombreCliente: "Juan Pérez",
            Fecha_creacion: "2024-01-01",
            Vencimiento: "12/2026",
            TipoTarjeta: "MASTERCARD",
            Estatus: "Activa"
        }
    ];

    return (
        <DataTable
            data={tarjetas.length > 0 ? tarjetas : getDefaultTarjetas()}
            columns={columns}
            idField="NumeroTarjeta"
            onSelectionChange={onSelectionChange}
            loading={loading}
            error={error}
            onRetry={onRetry}
            emptyStateNoReload={emptyStateNoReload}
            emptyMessage="No hay tarjetas registradas"
            className="tabla-tarjetas"
            pageSize={pageSize}
            currentPage={currentPage}
            onPageChange={onPageChange}
        />
    );
}

export default TablaTarjetas;
